import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Banknote } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { FinancialForecastPage } from "./pages/FinancialForecastPage";

/** Tabs on the Financial Forecast page. `calendar` is the default and is
 *  omitted from the URL; the P&L, runway and scenario views land here too. */
export type FinancialForecastTab = "calendar";

export interface FinancialForecastSearch {
  tab?: FinancialForecastTab;
}

export const FORECAST_TABS: readonly FinancialForecastTab[] = ["calendar"];

function validateSearch(search: Record<string, unknown>): FinancialForecastSearch {
  const out: FinancialForecastSearch = {};
  if (FORECAST_TABS.includes(search.tab as FinancialForecastTab)) {
    out.tab = search.tab as FinancialForecastTab;
  }
  return out;
}

export const financialForecastModule: FeatureModule = {
  key: "financial_forecast",
  nav: {
    label: "Financial Forecast",
    icon: Banknote,
    to: "/financial-forecast",
    requires: "financial_forecast.read",
    order: 10,
    group: "Finance",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/financial-forecast",
      component: guarded("financial_forecast.read", FinancialForecastPage),
      validateSearch,
    }),
  ] as unknown as AnyRoute[],
};
